export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q05_b.ce6a70c8.png";